import { useEffect, useState } from "react";
import useAreasFrameworks from "./useAreasFrameworks";

const useAreasSDGs = (planAreaDTOs) => {
    const { genericFwsRelated } = useAreasFrameworks(planAreaDTOs, [{ frameworkSuite: 'generic', fwIds: [2] }]);
    const [sdgs2030, setSdgs2030] = useState(null);

    useEffect(() => {
        if (planAreaDTOs && genericFwsRelated && genericFwsRelated.length == 1 && genericFwsRelated[0].level1sDTOs.length > 0) {
            setSdgs2030(genericFwsRelated[0]);
        } else {
            setSdgs2030(null);
        }
    }, [genericFwsRelated]);

    return { sdgs2030 };
}

export default useAreasSDGs;